export const CLIENT_SET_CURRENT = 'CLIENT_SET_CURRENT';
export const CLIENT_SET_INTEREST = 'CLIENT_SET_INTEREST';
export const CLIENT_SET_LIST = 'CLIENT_SET_LIST';
export const CLIENT_SET_ERROR = 'CLIENT_SET_ERROR';
export const CLIENT_SET_AGREEMENTS = 'CLIENT_SET_AGREEMENTS';
export const CLIENT_ORGANIZATIONS_LIST = 'CLIENT_ORGANIZATIONS_LIST';
export const CLIENT_ADD_TO_LIST = 'CLIENT_ADD_TO_LIST';
export const CLIENT_ADD_TO_INTEREST = 'CLIENT_ADD_TO_INTEREST';
export const CLIENT_SET_DOC_TYPES = 'CLIENT_SET_DOC_TYPES';

